import { SvgIconProps } from "@material-ui/core";
import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

const CheckboxCheckedHover = createSvgIcon(
  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3_15582)">
      <rect x="3" y="3" width="16" height="16" rx="4" fill="#009FB8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1754 6.76258C15.5827 7.13561 15.6105 7.76817 15.2374 8.17544C14.0843 9.43437 13.5299 10.2019 12.697 11.6922C12.3826 12.2548 12.0343 13.0352 11.7567 13.699C11.62 14.026 11.5041 14.3157 11.4225 14.5235C11.3817 14.6273 11.3496 14.7104 11.3279 14.7671L11.3032 14.8316L11.2971 14.8476L11.2957 14.8514C11.1716 15.1812 10.8828 15.4221 10.5359 15.4843C10.1891 15.5465 9.83511 15.4215 9.60417 15.1554L6.74469 11.8597C6.38275 11.4425 6.42751 10.811 6.84466 10.449C7.26182 10.0871 7.8934 10.1318 8.25534 10.549L10.0451 12.6118C10.3093 11.9954 10.6343 11.2834 10.9512 10.7165C11.8595 9.0911 12.5049 8.19765 13.7626 6.82457C14.1356 6.41731 14.7682 6.38955 15.1754 6.76258Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3_15582"
        x="0"
        y="0"
        width="22"
        height="22"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_3_15582"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.698039 0 0 0 0 0.929412 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3_15582"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3_15582"
          result="shape"
        />
      </filter>
    </defs>
  </svg>,
  "CheckboxCheckedHover"
);

export default (props: SvgIconProps) => (
  <CheckboxCheckedHover
    {...props}
    viewBox="0 0 22 22"
    transform="scale(1.357)"
  />
);
